/* global hidden_side */

window['employee_changelists#show'] = function () {
  $('.employee-changeset-toggle').click((e) => {
    e.preventDefault()

    const content = $(e.target).data('content')

    hidden_side.contentElement.addClass('loading')
    hidden_side.open()
    hidden_side.insertContent(content)
    hidden_side.contentElement.removeClass('loading')
  })
}
